<template>
  <section class="dashboard-sitters mb-64">
    <h3 class="text-h4">Sitters near {{ city }}</h3>
    <div class="flex gap-16 overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24 pt-16 max-w-screen">
      <SitterCard
        v-for="(sitter, index) in sitters"
        :key="index"
        customClasses="min-w-[212px]"
        :photoUrl="sitter.node.sitter.photoUrl"
        :name="sitter.node.sitter.name"
        :yearsExperience="sitter.node.yearsExperience"
        :minRate="sitter.node.minRate"
        :maxRate="sitter.node.maxRate"
        :avgRating="sitter.node.avgRating"
        :totalRatings="sitter.node.totalRatings"
        :sitterIdForProfile="sitter.node.sitter.id"
        :variant="smallVariant"
        :ariaLabel="`Explore Sitter ${sitter.node.sitter.name}`"
        target="_blank"
      />
    </div>
    <Button
      v-if="zipcode"
      class="p-0"
      variant="text"
      value="More sitters"
      :href="searchLinkUrl"
      :ariaLabel="`Sitters near ${city}`"
    />
  </section>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import SitterCard from '@/components/sitter_card/SitterCard.vue';
import SitterCardVariantTypes from '@/types/sitter_card';

export default {
  name: 'NearbySittersList',
  components: {
    Button,
    SitterCard,
  },
  props: {
    sitters: {
      type: Array,
      required: true,
    },
    zipcode: {
      type: String,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      smallVariant: SitterCardVariantTypes.Small,
    };
  },
  computed: {
    searchLinkUrl(): string {
      return `/availability/search?zipcode=${this.zipcode}&careType=babysitter`;
    },
  },
};
</script>
